import { z } from '@/libs/zod';

export const customerInfoSchema = z.object({
  id: z.string(),
  customerId: z.string(),
  cpf: z.string(),
  name: z.string(),
  phone: z.string(),
  birthDate: z.string(),
  email: z.string().email(),
  socialName: z.string(),
  leadId: z.string().optional(),
  balance: z.number().min(0).optional(),
  purchaseWithPromotion: z.boolean().optional(),
});

export type CustomerInfo = z.infer<typeof customerInfoSchema>;
